// extracted by mini-css-extract-plugin
export default {"blocker":"Cart_blocker__3APaS","checkout":"Cart_checkout__-5Ivz","total-price":"Cart_total-price__c-oNW"};